module.exports = __webpack_public_path__ + "img/profile-header.da214727.png";